export default {
  'kid-list:title': 'Картаны кімнің атына ресімдейсіз?',
  'kid-list:title-noAcceptable': 'Балаға арналған Kaspi Gold картасын тек 6 жастан 16 жасқа дейінгі өз балаларыңызға аштыра аласыз',
  'kid-list:age': 'жас',
  'kid-list:tip-1': '6 жастан асқан балаға ғана аштыруға болады',
  'kid-list:tip-2': 'Балаға арналған Kaspi Gold картасы бар',
  'kid-list:tip-3': 'Kaspi Gold картасын өз бетіңізбен аштыра алады',
  'kid-list:btn-to-main': 'Kaspi.kz бас бетіне қайту',
  'kid-list:guide-title': 'Жиі қойылатын сұрақтарға жауаптар'

}
